module.exports = __webpack_public_path__ + "img/a4.7f58ab81.png";